module.exports = __webpack_public_path__ + "img/testBench.ae291aa7.png";